import { AcpLinkExternalAccountSuccessSectionCtrl } from './acp-link-external-account-success-section-ctrl';
import acpLinkExternalAccountSuccessTemplate from './templates/acp-link-external-account-success.html';

export function acpLinkPaypalAccountSuccessStates($stateProvider: any) {
  'ngInject';

  $stateProvider.state('link-external-account-success', {
    controller: AcpLinkExternalAccountSuccessSectionCtrl,
    data: {
      gaLocation: 'external-account-link-success'
    },
    parent: 'root',
    resolve: {
      module: /* @ngInject */ ($ocLazyLoad) => {
        return import(/* webpackChunkName: "acp.section.link-external-account-success" */ 'sections/link-external-account-success').then(
          $ocLazyLoad.loadModule
        );
      }
    },
    template: acpLinkExternalAccountSuccessTemplate,
    url: '/external-account/link/success'
  });
}
